const SCRAPING_REVIEW_COMMENT_TYPE = {
  COMMENT: 'COMMENT',
  INFO: 'INFO',
}

export default SCRAPING_REVIEW_COMMENT_TYPE
